import { Constant } from "./layout.constant";
import { LayoutElement } from "./layout.element";
import { StringUtil } from "./layout.util";

class HtmlPaging {

    static paging(template, datasource) {
        for (let index = 0; index < template.children.length; index++) {
            const item = template.children[index];
            item.ax1 += template.offsetX;
            item.ay1 += template.offsetY;
            item.ax2 += template.offsetX;
            item.ay2 += template.offsetY;
            if (LayoutElement.ELEMENT_LIST == item.cls) {
                // 如果list的rowdata有值，则根据rowdata将数据源中的list结果集取出
                if (!StringUtil.isEmptyString(item.rowdata)) {
                    item.rows = this.#extractArray(item.rowdata, datasource);
                }

                const summary = {}
                summary[`acount`] = item.rows.length
                for (let index = 0; index < item.cols.length; index++) {
                    const col = item.cols[index];
                    summary[`asum(${col.field})`] = 0
                }
                for (let index = 0; index < item.rows.length; index++) {
                    const row = item.rows[index];
                    for (let index = 0; index < item.cols.length; index++) {
                        const col = item.cols[index];
                        summary[`asum(${col.field})`] = summary[`asum(${col.field})`] + StringUtil.toNumber(row[col.field])
                    }
                }
                item.summary = summary
            }
        }

        if (template.paperType == Constant.PAPER_TYPE_FIT) {
            let sumExt = 0;
            for (let index = 0; index < template.children.length; index++) {
                const item = template.children[index];
                if (LayoutElement.ELEMENT_LIST == item.cls) {
                    let height = item.ay2 - item.ay1;
                    if (item.title) {
                        // 如果表头显示减去表头
                        height -= item.titleHeight;
                    }
                    if (item.footer) {
                        // 如果表尾显示减去表头
                        height -= item.footerHeight;
                    }
                    item.pageRowCount = item.rows.length;
                    item.ay2 += item.rows.length * item.rowHeight - height;
                    sumExt += item.rows.length * item.rowHeight - height;
                    this.#offsetElementAy(template.children, item.ay1, sumExt);
                }
                template.height += Math.ceil(sumExt);
            }
            return 1;
        } else {
            let pageCount = 1;
            for (let index = 0; index < template.children.length; index++) {
                const item = template.children[index];
                if (LayoutElement.ELEMENT_LIST == item.cls) {
                    let height = item.ay2 - item.ay1;
                    if (item.title) {
                        // 如果表头显示减去表头
                        height = height - item.titleHeight;
                    }
                    if (item.footer) {
                        // 如果表尾显示减去表头
                        height = height - item.footerHeight;
                    }

                    if (height >= item.rowHeight) {
                        // 每页的行数
                        let pageRowCount = Math.floor(height / item.rowHeight);
                        // 设置分页信息到元素
                        item.pageRowCount = pageRowCount;
                        // 可以分几页
                        pageCount = Math.max(Math.ceil(item.rows.length / pageRowCount), pageCount);
                    }
                }
            }
            return pageCount
        }
    }

    static #extractArray(rowdatakey, datasource) {
        if (datasource.hasOwnProperty(rowdatakey) && Array.isArray(datasource[rowdatakey])) {
            return datasource[rowdatakey]
        } else {
            return []
        }
    }

    static #offsetElementAy(children, marky, offset) {
        children.forEach(item => {
            if (item.ay1 > marky) {
                item.ay1 += offset;
                item.ay2 += offset;
            }
        })
    }
}

export {
    HtmlPaging
}